import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-no-config-banner',
    templateUrl: './no-config-banner.component.html',
    styleUrls: ['./no-config-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoConfigBannerComponent {}
